import React, { useEffect, useState } from 'react'
import style from './ganttView.module.scss'
import GanttChart from '../../components/GantChart/GanttChart'
import { useAppSelector } from '../../starter/hooks/redux'
import dayjs from 'dayjs'
import { useLazyGetProjectEmployeeLinksQuery } from '../../starter/api/projectEmployeeLinksApi'

interface IGantt {
  data: IGanttData[]
  links?: any[]
}
interface IGanttData {
  id: string
  text: string
  start_date?: Date
  end_date?: Date
  order?: number
  progress?: number
  open?: boolean
  parent?: string
  color?: string
  duration?: number
  type?: string
  render?: string
  isForgotten?: boolean
}

const GanttView = () => {
  const { employees } = useAppSelector((state) => state.employees)
  const { projects } = useAppSelector((state) => state.projects)
  const { projectEmployeeLinks } = useAppSelector((state) => state.projectEmployeeLinks)
  const { sequenceProject } = useAppSelector((state) => state.sequenceProject)

  const { isSmall } = useAppSelector((state) => state.viewOptions.main)
  const { type, zoom } = useAppSelector((state) => state.gantt)

  const [dataProject, setDataProject] = useState<IGanttData[]>([])
  const [dataEmployee, setDataEmployee] = useState<IGanttData[]>([])

  const [data, setData] = useState<IGantt>({
    data: []
    // links: [{ id: 1, source: 1, target: 2, type: "0" }],
  })
  const [getProjectEmployeeLinks] = useLazyGetProjectEmployeeLinksQuery()

  useEffect(() => {
    getProjectEmployeeLinks()
  }, [])

  useEffect(() => {
    const _dataProject: IGanttData[] = projects
      .filter((project) => {
        if (type === 'employee' || !isSmall) {
          return true
        }
        if (sequenceProject.includes(project._id)) {
          return true
        }
        let result = false
        projectEmployeeLinks
          .filter((pel) => pel.project._id === project._id)
          .forEach((pel) => {
            const actual = pel.periods.find((p) => dayjs(p.startTime) <= dayjs() && dayjs() <= dayjs(p.endTime))
            if (actual) {
              result = true
            }
          })
        return result
      })
      .map((project) => {
        const allPeriodLength = dayjs(project.to).diff(dayjs(project.from), 'days')
        const currentPeriodLength = dayjs().diff(dayjs(project.from), 'days')
        const percent = Math.round((100 * currentPeriodLength) / allPeriodLength) / 100
        return {
          id: project._id,
          text: project.title,
          start_date: dayjs(project.from).toDate(),
          end_date: dayjs(project.to).toDate(),
          order: 10,
          progress: percent < 0 ? 0 : percent,
          type: 'project',
          open: false,
          isForgotten: !sequenceProject.includes(project._id)
        }
      })
    projectEmployeeLinks
      .filter((link) => {
        if (type === 'employee' || !isSmall) {
          return true
        }
        if (sequenceProject.includes(link.project._id)) {
          return true
        }
        let result = false
        projectEmployeeLinks
          .filter((pel) => pel.project._id === link.project._id)
          .forEach((pel) => {
            const actual = pel.periods.find((p) => dayjs(p.startTime) <= dayjs() && dayjs() <= dayjs(p.endTime))
            if (actual) {
              result = true
            }
          })
        return result
      })
      .forEach((link) => {
        _dataProject.push({
          id: link._id,
          text: `${link.employee.firstName} ${link.employee.lastName}`,
          order: 10,
          parent: link.project._id,
          render: 'split',
          isForgotten: !sequenceProject.includes(link.project._id)
        })
        link.periods.forEach((period) => {
          const allPeriodLength = dayjs(period.endTime).diff(dayjs(period.startTime), 'days')
          const currentPeriodLength = dayjs().diff(dayjs(period.startTime), 'days')
          const percent = Math.round((100 * currentPeriodLength) / allPeriodLength) / 100
          _dataProject.push({
            id: link._id + '-' + period.id,
            text: `${link.employee.firstName} ${link.employee.lastName}`,
            start_date: dayjs(period.startTime).toDate(),
            end_date: dayjs(period.endTime).toDate(),
            order: 10,
            progress: percent < 0 ? 0 : percent,
            parent: link._id
          })
        })
      })
    setDataProject(_dataProject)
  }, [isSmall, type, projects, projectEmployeeLinks, sequenceProject])

  useEffect(() => {
    const _dataEmployee: IGanttData[] = employees.map((employee) => {
      return {
        id: employee._id,
        text: `${employee.firstName} ${employee.lastName}`,
        order: 10,
        open: false,
        type: 'project',
        render: 'split',
        color: '#3db9d3'
      }
    })
    projectEmployeeLinks.forEach((link) => {
      link.periods.forEach((period) => {
        const allPeriodLength = dayjs(period.endTime).diff(dayjs(period.startTime), 'days')
        const currentPeriodLength = dayjs().diff(dayjs(period.startTime), 'days')
        const percent = Math.round((100 * currentPeriodLength) / allPeriodLength) / 100
        _dataEmployee.push({
          id: period.id,
          text: link.project.title,
          start_date: dayjs(period.startTime).toDate(),
          end_date: dayjs(period.endTime).toDate(),
          order: 10,
          progress: percent < 0 ? 0 : percent,
          parent: link.employee._id,
          open: true,
          color: '#65c16f'
        })
      })
    })
    setDataEmployee(_dataEmployee)
  }, [isSmall, type, employees, projectEmployeeLinks])

  useEffect(() => {
    setData({
      data: type === 'project' ? dataProject : dataEmployee
      // links: [{ id: 1, source: 1, target: 2, type: "0" }],
    })
  }, [type, dataProject, dataEmployee])

  return (
    <div className={style.wrapper}>
      <GanttChart tasks={data} zoom={zoom} />
    </div>
  )
}

export default GanttView
